<template>
    <q-dialog persistent ref="dialog" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section>
                <template v-if="headerText">
                    <div class="text-h6">{{ headerText }}</div>
                </template>
                <template v-else>
                    <div class="text-h6">Place order success</div>
                </template>
            </q-card-section>

            <q-card-section>
                <div class="text-subtitle1">Order ID</div>
                <q-input readonly outlined v-model="orderID">
                    <template v-slot:append>
                        <q-btn
                            @click="onCopyOrderID"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template>
                </q-input>
                <div class="text-subtitle1">Payment link</div>
                <q-input readonly outlined v-model="url">
                    <template v-slot:append>
                        <q-btn
                            @click="onCopy"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template>
                </q-input>
            </q-card-section>

            <q-card-actions align="right">
                <template v-if="canSendEmail">
                    <q-btn
                        unelevated
                        no-caps
                        :color="EmailSent ? `positive` : `primary`"
                        label="Send Email"
                        @click="onSendEmail"
                        :disable="EmailSent"
                        :loading="EmailSending"
                        :icon="EmailSent ? `checkbox` : undefined"
                    />
                </template>
                <q-btn
                    unelevated
                    no-caps
                    :color="SMSsent ? `positive` : `primary`"
                    label="Send SMS"
                    @click="onSendSMS"
                    :disable="SMSsent"
                    :loading="SMSsending"
                    :icon="SMSsent ? `checkbox` : undefined"
                />
            </q-card-actions>

            <q-separator />

            <!-- buttons example -->
            <q-card-actions align="right">
                <template v-if="!hideClearCart">
                    <q-btn
                        unelevated
                        no-caps
                        color="primary"
                        label="Close and Clear cart"
                        @click="onOKClick"
                    />
                </template>
                <q-btn
                    unelevated
                    no-caps
                    color="primary"
                    label="Cancel"
                    @click="onCancelClick"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import { copyToClipboard } from "quasar";
export default {
    name: "CheckoutCreateOrderSuccess",
    // props: ["text", "orderID", "headerText", "hideClearCart"],
    props: {
        text: {
            type: String,
        },
        orderID: {
            type: String,
        },
        phoneNumber: {
            type: String,
        },
        email: {
            type: String,
        },
        grandTotal: {
            type: Number,
        },
        headerText: {
            type: String,
        },
        hideClearCart: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            SMSsent: false,
            SMSsending: false,
            EmailSent: false,
            EmailSending: false,
        };
    },
    emits: [
        // REQUIRED
        "ok",
        "hide",
    ],
    computed: {
        url() {
            // return `https://portal.villamarket.net/pay/${this.text}`;
            const hostname = window.location.hostname;
            const protocol = window.location.protocol;
            const port = window.location.port ? `:${window.location.port}` : "";
            const path = `/pay3/${this.text}`;
            return `${protocol}//${hostname}${port}${path}`;
        },
        canSendEmail() {
            if (this.email == null || this.email == undefined) {
                return false;
            }
            return true;
        },
    },
    mounted() {
        console.log("mounted:", this.text);
    },
    methods: {
        async onSendSMS() {
            console.log("Send SMS");

            try {
                this.SMSsending = true;
                await this.$services.requestToPay.sendSMS({
                    orderId: this.orderID,
                    phoneNumber: this.phoneNumber,
                    grandTotal: this.grandTotal,
                    url: this.url,
                });
                this.SMSsent = true;
                this.SMSsending = false;
            } catch (error) {
                this.SMSsending = false;
                console.log(error);
            }
        },
        async onSendEmail() {
            console.log("Send Email");

            try {
                this.EmailSending = true;
                await this.$services.requestToPay.sendEmail({
                    orderId: this.orderID,
                    email: this.email,
                    grandTotal: this.grandTotal,
                    url: this.url,
                });
                this.EmailSent = true;
                this.EmailSending = false;
            } catch (error) {
                this.EmailSending = false;
                console.log(error);
            }
        },
        // following method is REQUIRED
        // (don't change its name --> "show")
        show() {
            this.$refs.dialog.show();
        },

        // following method is REQUIRED
        // (don't change its name --> "hide")
        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            // required to be emitted
            // when QDialog emits "hide" event
            this.$emit("hide");
        },

        onOKClick() {
            // on OK, it is REQUIRED to
            // emit "ok" event (with optional payload)
            // before hiding the QDialog
            this.$emit("ok");
            // or with payload: this.$emit('ok', { ... })

            // then hiding dialog
            this.hide();
        },

        onCancelClick() {
            // we just need to hide the dialog
            this.hide();
        },

        onCopy() {
            copyToClipboard(this.url);
        },

        onCopyOrderID() {
            copyToClipboard(this.orderID);
        },
    },
};
</script>
